export default __webpack_public_path__ + "56bd144.png";